export const ENTITY_LABELS: Record<string, string> = {
  event_id: "Events",
  venue_id: "Venues",
  artist_ids: "Artists",
  movie_id: "Movies",
  screening_id: "Screenings",
  performance_id: "Performances",
  play_id: "Plays",
  people: "People",
};

export const ENTITY_ORDER = [
  "event_id",
  "venue_id",
  "artist_ids",
  "movie_id",
  "play_id",
  "screening_id",
  "performance_id",
  "people",
];

export function labelFromKey(key: string): string {
  return key
    .replace(/_ids?$/, "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function entityHref(key: string, id: string): string | null {
  if (key === "event_id") return `/events/edit/${id}`;
  if (key === "venue_id") return `/venues/edit/${id}`;
  if (key === "artist_ids") return `/artists/edit/${id}`;
  return null;
}
